import { createClient } from '@supabase/supabase-js';

// Get Supabase URL and service role key from environment variables or runtime config
const getSupabaseUrl = () => {
  return window.REACT_APP_SUPABASE_URL || process.env.REACT_APP_SUPABASE_URL;
};

const getSupabaseServiceRoleKey = () => {
  return window.REACT_APP_SUPABASE_SERVICE_ROLE_KEY || process.env.REACT_APP_SUPABASE_SERVICE_ROLE_KEY;
};

// Create a Supabase client with service role key for admin operations
const supabaseUrl = getSupabaseUrl();
const supabaseServiceRoleKey = getSupabaseServiceRoleKey();

export let adminDb = null;

if (supabaseUrl && supabaseServiceRoleKey) {
  adminDb = createClient(supabaseUrl, supabaseServiceRoleKey);
} else {
  console.warn('Admin Supabase client not initialized. Service role key is not available in the client environment for security reasons.');
}

// IMPORTANT: This client should only be used in admin components
// and for operations that require bypassing RLS policies

// Admin database helpers
export const getAllUsers = async () => {
  if (!adminDb) {
    console.error('Admin operations are not available in the client environment for security reasons.');
    return [];
  }
  
  try {
    const { data, error } = await adminDb.auth.admin.listUsers();
    
    if (error) {
      console.error('Error fetching users:', error);
      return [];
    }
    
    return data?.users || [];
  } catch (error) {
    console.error('Error in getAllUsers:', error);
    return [];
  }
};

export const getStats = async () => {
  if (!adminDb) {
    console.error('Admin operations are not available in the client environment for security reasons.');
    return {
      totalUsers: 0,
      totalLeads: 0,
      totalBuyers: 0,
      totalSellers: 0
    };
  }
  
  try {
    // Get users count
    const { data: usersData } = await adminDb.auth.admin.listUsers();
    const totalUsers = usersData?.users?.length || 0;
    
    // Get leads count
    const { count: totalLeads } = await adminDb
      .from('leads')
      .select('*', { count: 'exact', head: true });
    
    // Get buyers count
    const { count: totalBuyers } = await adminDb
      .from('app_users')
      .select('*', { count: 'exact', head: true })
      .eq('role', 'buyer');
    
    // Get sellers count
    const { count: totalSellers } = await adminDb
      .from('app_users')
      .select('*', { count: 'exact', head: true })
      .eq('role', 'seller');
    
    return {
      totalUsers,
      totalLeads: totalLeads || 0,
      totalBuyers: totalBuyers || 0,
      totalSellers: totalSellers || 0
    };
  } catch (error) {
    console.error('Error in getStats:', error);
    return {
      totalUsers: 0,
      totalLeads: 0,
      totalBuyers: 0,
      totalSellers: 0
    };
  }
};

export default adminDb; 